<template>
  <v-container fluid>
    <v-row justify="space-around">
      <v-col lg="6" md="6" sm="12" xs="12">
        <span class="text-h3" id="farm">What we're farming 🚜</span>
      </v-col>
    </v-row>
    <v-row justify="space-around" v-for="item in orderedPositions" :key="item.title">
      <v-col lg="6" md="6" sm="12" xs="12">
        <front-page-position
            :title="item.title"
            :symbol="item.symbol"
            :messages="item.messages"
            :position-cost="item.positionCost"
            :summary="item.summary"
        />
      </v-col>
    </v-row>
    <v-row justify="space-around">
      <v-col lg="6" md="6" sm="12" xs="12" class="mt-4">
          <span class="text-h3" id="seed">What we're seeding 🌱</span>
      </v-col>
    </v-row>
    <v-row justify="space-around" v-for="item in seeds" :key="item.title">
      <v-col lg="6" md="6" sm="12" xs="12">
        <seed-position :title="item.title" :summary="item.summary" :symbol="item.symbol" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import FrontPagePosition from "@/components/FrontPagePosition";
import SeedPosition from "@/components/SeedPosition";

export default {
  name: "TheProcess",
  components: {SeedPosition, FrontPagePosition},
  data() {
    return {};
  },
  computed: {
    orderedPositions: function () {
      return this.$store.getters.getOrderedPositions;
    },
    seeds: function () {
      return [

      ];
    }
  }
}
</script>

<style scoped>

</style>